<p *ngIf="url" [ngClass]="{show: show}"><iframe [src]="url" *ngIf="shown"></iframe></p>